export const UPCOMING_INVOICES = "/v1/dashboard/upcoming-invoice";
export const UPCOMING_PAYMENTS = "/v1/dashboard/upcoming-payment";
export const SCHOOLS_IN_RED_STATUS = "/v1/dashboard/crm-status";
export const OVERDUE_INVOICES = "/v1/dashboard/overdue-invoice";
export const COLLECTIONS_SUMMARY = "/v1/dashboard/collection-summary";
export const LAB_STATUS_TRACKER = "/v1/dashboard/lab-status-tracker";
export const LAB_TASK_STATUS = "/v1/dashboard/lab-task-tracker"